/**
 * 判断是否为完整地址的函数
 * @param url 地址
 * @returns
 */
export function isFullUrl(url: string) {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}
